<template>
  <div>
    <div v-if="!loadPage && !localChangeC">
      <b-button v-for="(item) in buttons"
                :key="item.name"
                @click="item.m(vid)"
                :variant="item.variant"
                :title="item.description"
                class="col-12">
        <h3>{{item.name}}
          <i :class="item.icon"></i>
        </h3>
      </b-button>
      <hr>
      <luma-datatable :model="vserverBackups"
                      :url="urlC"
                      :columns="columns">
        <template v-slot:actions="slotProps">
          <b-button variant="white small" size="xs"
                    @click="restoreBackup(slotProps.item.id)">
            Wiederherstellen
          </b-button>
          <b-button variant="white small" size="xs" @click="delBackup(slotProps.item.id)">
            Löschen
          </b-button>
        </template>
      </luma-datatable>
    </div>
  </div>
</template>

<script>
  import {VserverBackups} from "@/store/models/vserver/vserver_backups";
  import axios from "@/store/vue-axios"
  import LumaDatatable from "@/components/LumaDatatable";
    export default {
        name: "luma-backups-vserver",
        components: {LumaDatatable},
        props:{loadPage:Boolean},
        data:()=>({
            localChange:false,
            backups:null,
            vserverBackups: VserverBackups,
            buttons:[
                {
                    name:'Backup erstellen',
                    icon:'fa fa-hdd-o',
                    description:'ERKLÄR',
                    variant:'outline-success',
                    m: (y)=> {
                        const x = axios.post("/datacenter/vservers/"+y+"/createBackup")
                    }
                }
            ]
        }),
        computed:{
            localChangeC(){
                return this.localChange
            },
            columns(){
                const x = new VserverBackups
                delete x.$id
                return Object.keys(x).map(el=>(el !== 'actions' ? {
                    key:el,
                    column:el,
                    filter:true,
                    order:true
                }: {
                    key:el,
                    column:el,
                    filter:true,
                    order:true,
                    slot:true
                }))
            },
            vid(){
                return this.$route.params.id
            },
            urlC(){
                return "/datacenter/vservers/"+this.vid+"/backups"
            }
        },
        methods:{
            async delBackup(val){
                console.log("DEL BACKUP::::",val)
                const x = await axios.delete("/datacenter/vservers/backups/"+val+"/delete")
                VserverBackups.delete(val)
                this.loadData = false
                const y = await setTimeout('',1000)
                this.loadData = true
            },
            async restoreBackup(val){
                console.log("RESTORE BACKUP::::",val)
                const x = await axios.post("/datacenter/vservers/backups/"+val+"/restore")
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/luma-backups-vserver.vue